const faq = require("./images/faq-handyman.png");

export default () => {
  const faqsList = [
    {
      q: "Are there hidden fees?",
      a: "No! Create a FREE account and leave your request to find a handyman expert. Find expert near you absolutely FREE.",
    },
    {
      q: "How quickly will there be a response to my request?",
      a: "We treat every request responsibly and usually suitable handymans are available within 5 min.",
    },
    {
      q: "How can I contact handyman?",
      a: "After you create a request, you will receive get a call about a handyman who meets your requirements appears.",
    },
    {
      q: "Who will I pay for work done?",
      a: "You will pay the handyman directly. Our goal is to find and connect you with a suitable handyman who fits your needs.",
    },
    {
      q: "Who are your handymans?",
      a: "Handymans are specialists registered on our platform who work for themselves or workers of our partners.",
    },
    {
      q: "Can I become a handyman on your platform?",
      a: "Yes! You can register as a handyman and be hired for the next project.",
    },
  ];

  return (
    <section className="py-14" id="qa">
      <div className="max-w-screen-xl mx-auto px-4 gap-12 md:flex md:px-8">
        <div className="flex-1">
          <div className="max-w-lg">
            <h3 className="font-semibold text-sky-600">
              Frequently asked questions
            </h3>
            <p className="mt-3 text-gray-800 text-3xl font-extrabold sm:text-4xl">
              All information you need to know
            </p>
            <img src={faq} />
          </div>
        </div>
        <div className="flex-1 mt-12 md:mt-0">
          <ul className="space-y-4 divide-y">
            {faqsList.map((item, idx) => (
              <li className="py-5" key={idx}>
                <summary className="flex items-center justify-between font-semibold text-gray-700">
                  {item.q}
                </summary>
                <p
                  dangerouslySetInnerHTML={{ __html: item.a }}
                  className="mt-3 text-gray-600 leading-relaxed"
                ></p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
